import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { Wizard, useWizard } from 'react-use-wizard';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap'
import useWizardContext from '../contexts/WizardContext';
import * as yup from "yup"
// import Uppy from "@uppy/core";
// import Webcam from "@uppy/webcam";
// import ImageEditor from '@uppy/image-editor';
// import ThumbnailGenerator from '@uppy/thumbnail-generator'
// import Compressor from '@uppy/compressor'
// import { Dashboard } from "@uppy/react";
// import '@uppy/core/dist/style.css';
// import '@uppy/dashboard/dist/style.css';
// import '@uppy/webcam/dist/style.css';
// import '@uppy/image-editor/dist/style.css';
import LabelBold from './widgets/LabelBold';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useClinicService } from '../services/ClinicService'

const schema = yup.object().shape({
    //insuranceCards: yup.mixed().transform((curr, orig) => orig === '' ? null : curr),
    additionalComments: yup.string().trim(),
    //filepond: yup.array().nullable().of(yup.string())
}).required();

const StepServicesRequested = () => {

    const btnSubmitRef = useRef();

    const {
        isLoading,
        isLastStep,
        isFirstStep,
        activeStep,
        stepCount,
        previousStep,
        nextStep,
        goToStep,
        handleStep,
    } = useWizard();

    const { /*valueA, valueB,*/ reducer, StepState, setActiveStep } = useWizardContext()

    console.log('Inside Step 2 and activeStep', activeStep, StepState[1])
    const [state, dispatch] = useReducer(reducer, StepState[1]);
    const [prevState, setPrevState] = useState(StepState[0]);

    const getDefaultFormValues = useCallback(() => {
        const {
            // eslint-disable-next-line no-unused-vars
            isSubmitted,
            // eslint-disable-next-line no-unused-vars
            errors,
            // eslint-disable-next-line no-unused-vars
            data,
            // eslint-disable-next-line no-unused-vars
            submitResults,
            // eslint-disable-next-line no-unused-vars
            setValue: setValueThrowAway,
            // eslint-disable-next-line no-unused-vars
            disableNavigationLastStep,
            ...formFields
        } = StepState[activeStep]

        return formFields
    }, [])

    const {
        register,
        setValue,
        getFieldState,
        handleSubmit,
        trigger,
        //control
        formState: { errors, isSubmitted }
    } = useForm({
        defaultValues: getDefaultFormValues(),
        resolver: yupResolver(schema),
    });

  const doRegister = (fieldName, isSubmitted, errors, registerMe = false) => {
    let registerAttr = {}
    if (registerMe) {
      registerAttr = {registerMe: () => register(fieldName)}
    }
    else {
      registerAttr = {...register(fieldName)}
    }

    const hasError = !!errors?.[fieldName];
    const result = {
      ...registerAttr,
      "aria-invalid": hasError ? "true" : "false"        
    };

    // Only add invalid prop when it's true, otherwise omit it
    if (hasError) {
      result.invalid = true;
    }

    // Only add valid prop when form is submitted and there are no errors
    if (isSubmitted && !hasError) {
      result.valid = true;
    }

    return result;
  }
  
  const doRegisterInput = (fieldName, isSubmitted, errors, context) => {
    return {
      ...doRegister(fieldName, isSubmitted, errors),
      value: context[fieldName],
      onChange: (e) => dispatch({ type: 'SET', name: e.target.name, value: e.target.value })
    }
  }
   
    const checkCMT = async () => {

        if (state.evFields.filter(x => x.group === "Other").length === 0) {
            await loadOtherGroup();

            otherGroups.forEach(item => {
                otherFieldsGroup.fields.push({
                    field: 'Other_' + item.cptCodeName,
                    label: item.cptCodeName,
                    defaultValue: false
                });
            });

            let newArray = [];
            newArray.push(otherFieldsGroup);

            let extendedFields = { evFields: newArray }
            newArray.forEach(evGroup => {
                evGroup.fields.forEach(evField => {
                    extendedFields[evField.field] = evField.defaultValue || false
                });
            });

            let newOtherGroups = state.evFields;

            if (extendedFields.evFields.length > 0)
                newOtherGroups.push(extendedFields.evFields[0]);

            dispatch({ type: 'SET', name: 'evFields', value: newOtherGroups });
        }

        state.evFields.forEach((group) => {
            group.fields.forEach((field) => {

                if (group.group === 'DME' && prevState.isDME === true) {
                        field.defaultValue = prevState.isDME;
                        dispatch({ type: 'SET', name: field.field, value: prevState.isDME });

                    dispatch({ type: 'SET', name: 'isDME', value: prevState.isDME });
                }
                else if (group.group === 'MED') {
                    const fieldName = field.field;

                    // If isDoctorTitle is true, use logic based on MED_J prefix
                    if (prevState.isDoctorTitle) {
                        const isChecked = fieldName.startsWith('MED_J');
                        field.defaultValue = isChecked;
                        dispatch({ type: 'SET', name: fieldName, value: isChecked });
                    } else {
                        // Otherwise, use value from prevState.PrescriberCPT
                        const matchingKey = Object.keys(prevState.clinic).find(
                            key => key.toLowerCase() === fieldName.toLowerCase()
                        );

                        if (matchingKey) {
                            field.defaultValue = prevState.PrescriberCPT[matchingKey];
                            dispatch({ type: 'SET', name: fieldName, value: prevState.PrescriberCPT[matchingKey] });
                        }
                    }
                }
                else if (group.group === 'Other') {
                    const fieldName = field.field;

                    // Find the matching key in StepState[0].clinic (case-insensitive)
                    const matchingKey = prevState.clinicOtherGroup.find(key => key.cptCodeName.toLowerCase() === fieldName.substring(6).toLowerCase());

                    if (matchingKey) {
                        field.defaultValue = matchingKey.defaultValue.toLowerCase() === 'true';
                        dispatch({ type: 'SET', name: fieldName, value: matchingKey.defaultValue.toLowerCase() === 'true' });
                    }
                }
                else {
                    const fieldName = field.field;
                    const clinicKeys = Object.keys(prevState.clinic);

                    // Find the matching key in StepState[0].clinic (case-insensitive)
                    const matchingKey = clinicKeys.find(key => key.toLowerCase() === fieldName.toLowerCase());

                    if (matchingKey) {
                        field.defaultValue = prevState.PrescriberCPT[matchingKey];
                        dispatch({ type: 'SET', name: fieldName, value: prevState.PrescriberCPT[matchingKey] });
                    }
                }
            });
        });
        const cptGroups = JSON.parse(prevState.clinicCPT.content);
        const allowedGroups = cptGroups.reduce((acc, group) => {
            acc[group.code] = group.order;
            return acc;
        }, {}); 

        let groups = {
            ...allowedGroups,
            Other: Object.keys(allowedGroups).length
        }

        let filteredGroups = state.evFields.filter(group => groups[group.group]);

        filteredGroups.sort((a, b) => groups[a.group] - groups[b.group]);

        dispatch({ type: 'SET', name: 'evFields', value: filteredGroups });

    };

    // useEffect(() => {
    //   console.log('valueA', valueA)
    //   console.log('valueB', valueB)
    //   console.log('StepState[activeStep]', StepState[activeStep])
    // }, [])


    let otherGroups = [];
    const otherFieldsGroup = {
        group: 'Other',
        label: 'Additional Requested Codes',
        fields: []
    };

    const loadOtherGroup = async () => {
        var data = await clinicService.GetOtherGroups(prevState.provider.value);

        //if (!data) {
        //    navigate('/')
        //}

        otherGroups = data;
    }

    useEffect(() => {

        //if (!prevState.isDoctorTitle) {
        //    dispatch({ type: 'SET', name: 'evFields', value: state.evFields.filter(group => group.group !== 'MED') })
        //}
        if (state.isSubmitted === false && isSubmitted) {
            dispatch({ type: 'SET', name: 'isSubmitted', value: isSubmitted })
        }

    dispatch({ type: 'SET', name: 'setValue', value: setValue })
  }, [setValue, state.isSubmitted, isSubmitted, state.isDME])

    useEffect(() => {
        //dispatch({ type: 'CHANGE_STEP', name: 'activeStep', value: activeStep })
        setActiveStep(activeStep)
    }, [activeStep, setActiveStep])

  //trigger will change on the first load. It's only way to run the validation on the default values.
    useEffect(() => {
      checkCMT();
    if (state.isSubmitted) {
      trigger()
      //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: false })
    }
    }, [trigger, state.isSubmitted])

    // useEffect(() => {
    //   if (state.insuranceCards.length !== 0) {
    //     const newFiles = []
    //     state.insuranceCards.forEach(file => {
    //       console.log('Type', file)
    //       console.log('getMetadata', file.getMetadata())
    //       console.log('file.file', file.file)
    //       console.log('file.origin', file.origin)
    //       console.log('file.source', file.source)
    //       file.origin = 2
    //       newFiles.push(file)
    //     });
    //     dispatch({ type: 'SET', name: 'insuranceCards', value: newFiles })
    //   }
    // }, [state.insuranceCards])

    // // Async function
    // handleStep(async () => {
    //   await fetch(...);
    // });

    // // Return promise
    // handleStep(() => {
    //   return fetch(...);
    // });

    /*const uppy = useMemo(() => { return new Uppy({
        autoProceed: false,
        allowMultipleUploads: false,
        restrictions: {
          maxFileSize: 50000000,
          maxNumberOfFiles: null,
          minNumberOfFiles: null,
          allowedFileTypes: [
            //".bmp",
            //".csr",
            //".csv",
            //".doc",
            //".docx",
            //".eml",
            ".jpg",
            ".jpeg",
            //".msg",
            //".p7m",
            ".pdf",
            ".png",
            //".ppt",
            //".pptx",
            //".tif",
            //".tiff",
            //".txt",
            //".vsd",
            //".xls",
            //".xlsx",
            //".xml",
            //".xps",
            //".zip"
          ]
        }
      })
      .use(ImageEditor, {
        id: 'ImageEditor',
        quality: 0.8,
        cropperOptions: {
          viewMode: 1,
          background: false,
          autoCropArea: 1,
          responsive: true,
        },
      })
      .use(ThumbnailGenerator, {
        id: 'ThumbnailGenerator',
        thumbnailWidth: 200,
        // thumbnailHeight: 200 // optional, use either width or height,
        waitForThumbnailsBeforeUpload: false,
      })
      .use(Webcam, {
        id: 'Webcam',
        modes: ['picture'],
      })
      .use(Compressor)
      .on("complete", result => console.log("YAH"))
      .on('thumbnail:generated', (file, preview) => {
        const img = document.createElement('img')
        img.src = preview
        img.width = 100
        document.body.appendChild(img)
      })
    }, []);
    */

    // const GetFilePond = ({sourceName}) => {

    //   //const files = {state[sourceName]}

    //   // return FilePond.Create({
    //   //   files: state[sourceName],
    //   //   captureMethod: ['camera'],
    //   //   //acceptedFileTypes={['image/png', 'image/jpeg', 'image/gif']}
    //   //   acceptedFileTypes: ['image/*'],
    //   //   allowReorder: true,
    //   //   allowMultiple: true,
    //   //   onupdatefiles: (files) => dispatch({ type: 'SET', name: sourceName, value: files }),
    //   //   labelIdle: 'Drag & Drop your insurance card photos or <span class="filepond--label-action">Browse</span>'
    //   // })

    //   return (
    //     <FilePond
    //       files={state[sourceName]}
    //       captureMethod={['camera']}
    //       //acceptedFileTypes={['image/png', 'image/jpeg', 'image/gif']}
    //       acceptedFileTypes={['image/*']}
    //       allowReorder={true}
    //       allowMultiple={true}
    //       onupdatefiles={(files) => dispatch({ type: 'SET', name: sourceName, value: files })}
    //       labelIdle='Drag & Drop your insurance card photos or <span class="filepond--label-action">Browse</span>'
    //     />
    //   )
    // }
    const clinicService = useClinicService();


    const formRef = useRef(null)

    const setDisabledLastStep = (state) => {
        if (btnSubmitRef && btnSubmitRef.current) {
            if (state) {
                btnSubmitRef.current.setAttribute("disabled", "disabled");
            }
            else {
                btnSubmitRef.current.removeAttribute("disabled");
            }
        }
    }

    const submitAll = (e) => {
        //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: true })
        console.log('🔵 DEBUG: Submit button clicked'); // 
        formRef.current.props.onSubmit(e)
    }

    const onSubmit = async (data, e) => {
        console.log('🔵 DEBUG: onSubmit called with data:', data);
        dispatch({ type: 'SET', name: 'errors', value: [] })
        dispatch({ type: 'SET', name: 'data', value: data })
        dispatch({ type: 'SET', name: 'isSubmitted', value: true })

        console.log('+++++++++++++++++++++++++++++++++', data)
        //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: true });
        setDisabledLastStep(true)

        console.log('🔵 DEBUG: About to call submitResults'); // ADD THIS
        const jumpToErrorStep = await state.submitResults(isLastStep, data)
        console.log('jumpToErrorStep', jumpToErrorStep)
        if (jumpToErrorStep !== -1) {
            goToStep(jumpToErrorStep)
            //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: false });
            setDisabledLastStep(false)
        }

        console.log(data, e);
    }

    const onError = (errors, e) => {
        dispatch({ type: 'SET', name: 'errors', value: errors })
        console.log(errors, e)
    }

    const onCheckedChanged = (e) => {
        dispatch({ type: 'SET', name: e.target.name, value: e.target.checked })
    }

    const renderGroup = (group) => {
        if (!group.fields || group.fields.length === 0) return null;
        // const chunkSize = 3
        // var rows = [];
        // for (var i = 0; i < group.fields.length; i += chunkSize)
        //   rows.push(group.fields.slice(i, i + chunkSize));
   
        return (
            <React.Fragment key={group.group}>
                <Row className='mt-5 mb-3' key={`${group.group}-header`}>
                    <Col xs={12}>
                        <LabelBold>{group.label}</LabelBold>
                    </Col>
                </Row>
                <Row className='mb-3' key={`${group.group}-options`}>
                    {
                        group.fields.map((evField, jindex) => {
                            return (
                                <Col md={6} xl={4} key={`${group.group}-${jindex}`}>
                                    <FormGroup>
                                        <Label check>
                                            <Input type='checkbox'
                                                name={evField.field}
                                                id={evField.field}
                                                //value={index}
                                                checked={state[evField.field] || false}
                                                onChange={onCheckedChanged}
                                            >
                                            </Input> {evField.label}
                                        </Label>
                                    </FormGroup>
                                </Col>
                            )
                        })
                    }
                </Row>
            </React.Fragment>
        )
    }

    // const getCards = () => {
    //   const newCards = [];

    //   state.insuranceCards.forEach(file => {
    //     //file.setMetadata('customServerId', file.serverId)
    //     //file.setMetadata('suckThe', "D")

    //     console.log('Getting metadata in getCards', file.getMetadata('customServerId'))
    //     //file.source = file.getMetadata('customServerId')
    //     //file.serverId (file.getMetadata('customServerId'))

    //     var json = JSON.stringify(file)
    //     var obj = JSON.parse(json)
    //     //obj.source = file.getMetadata('customServerId') //file.source//file.getMetadata('customServerId')//file.source//file.getMetadata('customServerId')
    //     obj.serverId = file.getMetadata('customServerId')
    //     obj.Metadata = {
    //       customServerId: obj.serverId
    //     }
    //     console.log('json', obj)
    //     //var obj = JSON.

    //     console.log(file.source)

    //     newCards.push(obj)
    //   })

    //   return newCards
    // }

    return (
        <div className='mb-3'>
            <Form ref={formRef} onSubmit={handleSubmit(onSubmit, onError)/*((d) => console.log('d', d))*/}>
                {
                    //renderGroup(state.evFields[0])                    
                    state.evFields.map(group => renderGroup(group))
                }

                <Row className='mt-5 wizard-footer'>
                    <Col xs={{ size: 6 }} md={{ size: 5, offset: 1 }} lg={{ size: 3, offset: 3 }}>
                        <Button color="secondary" onClick={() => previousStep()}><ArrowLeft /> Back</Button>
                    </Col>
                    <Col xs={{ size: 6 }} md={{ size: 5 }} lg={{ size: 3 }} className='text-end'>
                        <Button innerRef={btnSubmitRef} name="submitButton" id="submitButton" color="primary" className='ms-3' onClick={() => submitAll()} /*disabled={state.disableNavigationLastStep}*/>Submit <ArrowRight /></Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default StepServicesRequested